/**
 * Por que um review não abre, ou `null` quando abre. Regra única da lista (menu "Abrir
 * Review") e da tela do review — que é onde terminam todos os caminhos: lista, cards do
 * dashboard e link colado. Com a regra só na lista, o dev abria pelo dashboard o review
 * com erro que a lista fechava.
 *
 * - Concluído abre; "Pendente" (processado sem a análise do assistente) também: é ali que
 *   se vê o que foi processado e se pede a análise.
 * - Com erro (failed/dead) abre só para quem tem visão global (admin, audit, superuser):
 *   é o diagnóstico do que faltou antes de reprocessar. Para os demais fica fechado até
 *   ser reprocessado — a tela abriria pela metade, sem dizer o que faltou.
 * - Na fila ou processando não abre: ainda não há o que ver.
 *
 * É regra de interface. Quem pode ver qual review decide o backend, pela visibilidade.
 */
export type ReviewOpenBlock = 'in-progress' | 'failed' | null;

const FAILED = ['failed', 'dead'];
const OPEN_STEPS = ['complete', 'assistant-pending'];

export function reviewOpenBlock(
  statusDerived: string | undefined,
  currentStep: string | undefined,
  globalView: boolean
): ReviewOpenBlock {
  const status = (statusDerived || '').toLowerCase().trim();
  // Sem passo informado, concluído é "complete" — a mesma leitura de resolveStep na lista.
  const step = ((currentStep || '').trim() || (status === 'done' ? 'complete' : '')).toLowerCase();
  if (status === 'done' && OPEN_STEPS.includes(step)) { return null; }
  if (FAILED.includes(status)) { return globalView ? null : 'failed'; }
  return 'in-progress';
}
